import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AvatarSourceType } from './create.state';

/**
 * Actions for avatar create feature.
 *
 * @exports
 */
export const AvatarCreateActions = createActionGroup({
  source: 'AvatarCreate',
  events: {
    // Flow initialization
    'Initialize Flow': emptyProps(),

    // Photo capture/selection
    'Open Camera': emptyProps(),
    'Open Gallery': emptyProps(),
    'Photo Selected': props<{
      dataUrl: string;
      sourceType: AvatarSourceType;
      blob?: Blob;
    }>(),
    'Photo Selection Failed': props<{ error: string }>(),
    'Retake Picture': emptyProps(),

    // Avatar upload
    'Upload Avatar': emptyProps(),
    'Upload Avatar Success': props<{
      avatarId: string;
      estimatedTime?: string;
    }>(),
    'Upload Avatar Failed': props<{ error: string }>(),
    'Validation Error': props<{ error: string }>(),

    // Status polling
    'Start Polling': props<{ avatarId: string }>(),
    'Poll Status': emptyProps(),
    'Poll Status Success': props<{ status: string; data?: any }>(),
    'Poll Status Failed': props<{ error: string }>(),
    'Stop Polling': emptyProps(),
    'Polling Timeout': emptyProps(), // After 10 seconds
    'Polling Max Attempts Reached': emptyProps(),

    // Avatar completion
    'Avatar Completed': props<{ avatarId: string }>(),
    'Avatar Failed': props<{ error: string }>(),

    // Navigation
    'Navigate To Home': emptyProps(),
    'Navigate To Create': emptyProps(),

    // State management
    'Set Step': props<{ step: string }>(),
    'Reset State': emptyProps()
  }
});
